export default __webpack_public_path__ + "static/media/cityEn.2a6557a7.png";